/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ReadyToSubmit/view.blocks to change it.
import "DesignSystem/Fonts/Inter-300.css"
import Button from 'DesignSystem/Button/index'
import React from 'react'
import styles from './view.module.css'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function ReadyToSubmit({
  children,
  viewPath = "/App/Form/Progress/ReadyToSubmit",
  isDisabled,
  onClick
  
}) {
  return (<React.Fragment
>
<span
  data-testid="ReadyToSubmit.Text"
  data-view-path={viewPath}
 className={`views-text ${styles.Text}`}
>
Review the information and
</span>
<Button
  viewPath={`${viewPath}/Button`}
 alignSelf="center"
 marginLeft={0}
 marginTop={0}
 isDisabled={isDisabled}
 onClick={onClick}
 paddingLeft={30}
 paddingRight={30}
 text="Confirm Booking"
 width={200}
/>
{children}
</React.Fragment>)
}